import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Share2, X, Loader2 } from 'lucide-react';
import { API } from '../config';
import { inviteShareText, shareText, trackShare } from '../lib/referralShare';

const post = (action) => axios.post(`${API}/referral/share-nudge`, { action }).catch(() => {});

// Small box under a new Multipla IA / saved selection: max once a day, never again after 3 closes without sharing
export const ShareNudge = () => {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const asked = useRef(false);

  useEffect(() => {
    if (asked.current) return;
    asked.current = true;
    axios.get(`${API}/referral/share-nudge`).then((r) => {
      if (r.data?.show) { setShow(true); post('shown'); }
    }).catch(() => {});
  }, []);

  if (!show) return null;

  const close = () => { setShow(false); post('dismissed'); };
  const share = async () => {
    setBusy(true);
    trackShare('nudge');
    post('shared');
    try {
      const text = await inviteShareText('nudge');
      if (text) await shareText(text, 'Condividi con un amico');
    } finally { setBusy(false); setShow(false); }
  };

  return (
    <div className="mt-3 relative rounded-2xl border border-[#F5A623]/30 bg-[#F5A623]/5 p-3 pr-9 flex items-center gap-3" data-testid="share-nudge">
      <p className="flex-1 text-xs text-gray-200 leading-snug" data-testid="share-nudge-text">Conosci qualcuno che segue queste partite? Condividila con un amico 👥</p>
      <button type="button" onClick={share} disabled={busy} className="h-9 px-3 rounded-full bg-[#F5A623] text-[#1A1A1A] text-xs font-black flex items-center gap-1.5 shrink-0 active:scale-95 transition-transform disabled:opacity-60" data-testid="share-nudge-share-btn">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Share2 className="w-3.5 h-3.5" />} Condividi
      </button>
      <button type="button" onClick={close} aria-label="Chiudi" className="absolute top-1.5 right-1.5 p-1 text-gray-500 hover:text-white" data-testid="share-nudge-close-btn">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ShareNudge;
